export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    fiscalYear = "",
    groups = [],
    totalPages = "1",
    openingDate = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
    signingDay = "",
    signingMonth = "",
    signingYear = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  let rowsHtml = "";
  groups.forEach((group, gIdx) => {
    // Group Header
    rowsHtml += `
      <tr bgcolor="#F9F9F9" style="font-weight: bold;">
        <td class="border text-center">${gIdx + 1}</td>
        <td class="border" colspan="8" style="padding-left: 8px;">${group.associateName}</td>
      </tr>
    `;

    // Items
    (group.items || []).forEach((item) => {
      rowsHtml += `
        <tr>
          <td class="border text-center">${item.documentNumber || ""}</td>
          <td class="border text-center">${item.documentDate || ""}</td>
          <td class="border px-1">${item.description || ""}</td>
          <td class="border text-right px-1">${fmt(item.openingValue)}</td>
          <td class="border text-right px-1">${fmt(item.profitShareAdjustment)}</td>
          <td class="border text-right px-1">${fmt(item.differentReportingDateAdjustment)}</td>
          <td class="border text-right px-1">${fmt(item.accountingPolicyAdjustment)}</td>
          <td class="border text-right px-1">${fmt(item.otherEquityAdjustment)}</td>
          <td class="border text-right px-1 font-bold">${fmt(item.closingValue)}</td>
        </tr>
      `;
    });
  });

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 13px; color: black; line-height: 1.4;">
      <table width="100%">
        <tr>
          <td width="60%" valign="top">
            <div class="font-bold">Đơn vị: <span style="font-weight: normal; border-bottom: 1px dotted black;">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span style="font-weight: normal; border-bottom: 1px dotted black;">${address}</span></div>
          </td>
          <td width="40%" align="center">
            <div class="font-bold">Mẫu số S41b-DN</div>
            <div style="font-style: italic; font-size: 11px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 30px 0;">
        <h2 style="margin: 0; text-transform: uppercase;">SỔ KẾ TOÁN CHI TIẾT THEO DÕI CÁC KHOẢN ĐẦU TƯ VÀO CÔNG TY LIÊN KẾT</h2>
        <div style="margin-top: 10px;">Năm tài chính: <span style="border-bottom: 1px dotted black; padding: 0 10px;">${fiscalYear}</span></div>
      </div>

      <table width="100%" style="border-collapse: collapse; margin-top: 20px;">
        <thead>
          <tr>
            <th class="border" colspan="2">Chứng từ</th>
            <th class="border" rowspan="2">Diễn giải</th>
            <th class="border" rowspan="2" width="100">Giá trị ghi sổ đầu kỳ (1)</th>
            <th class="border" colspan="4">Các khoản được điều chỉnh tăng (giảm) giá trị ghi sổ của khoản đầu tư</th>
            <th class="border" rowspan="2" width="100">Giá trị ghi sổ cuối kỳ (6)</th>
          </tr>
          <tr>
            <th class="border" width="60">Số hiệu</th>
            <th class="border" width="60">Ngày tháng</th>
            <th class="border" style="font-size: 10px;">Tương ứng phần sở hữu trong lãi/lỗ (2)</th>
            <th class="border" style="font-size: 10px;">Báo cáo tài chính lập khác ngày (3)</th>
            <th class="border" style="font-size: 10px;">Chính sách hợp nhất không thống nhất (4)</th>
            <th class="border" style="font-size: 10px;">Thay đổi vốn chủ sở hữu khác (5)</th>
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">B</th>
            <th class="border">C</th>
            <th class="border">1</th>
            <th class="border">2</th>
            <th class="border">3</th>
            <th class="border">4</th>
            <th class="border">5</th>
            <th class="border">6</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
        </tbody>
      </table>

      <div style="margin-top: 25px;">
        <div>- Sổ này có <span style="border-bottom: 1px dotted black; padding: 0 10px;">${totalPages}</span> trang, đánh số từ trang 01 đến trang...</div>
        <div style="margin-top: 5px;">- Ngày mở sổ: <span style="border-bottom: 1px dotted black; padding: 0 10px;">${openingDate}</span></div>
      </div>

      <table width="100%" style="margin-top: 40px; text-align: center;">
        <tr>
          <td width="33%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 80px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="33%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 80px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="33%">
            <div style="font-style: italic; font-size: 11px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 80px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>
    </div>

    <style>
      .border { border: 1px solid black; }
      .text-center { text-align: center; }
      .text-right { text-align: right; }
      .font-bold { font-weight: bold; }
      .px-1 { padding: 0 4px; }
    </style>
  `;
};
